import React from 'react';
import { formatPrice } from '@app/src/utils/normalize';
import {
  Wrapper,
  Igv,
  Price
} from './styled';

interface Props {
  priceTotal?: number;
  bgColor?: string;
  handleClick?: Function;
  className?: string;
}

export const PriceConcept: React.FC<Props> = ({
  priceTotal,
  bgColor,
  handleClick,
  className
}) => (
  <Wrapper
    className={className}
    bgColor={bgColor}
    onClick={e => handleClick && handleClick(e)}
  >
    {
      formatPrice(priceTotal) !== '00.00' ?
        <React.Fragment>
          <span>Total a pagar <Igv>(Inc. IGV)</Igv></span>
          <Price>S/ {formatPrice(priceTotal)}</Price>
        </React.Fragment>
      :
        'Las tarifas incluyen IGV.'
    }
  </Wrapper>
);
